import React from 'react';
import ReactDOM from 'react-dom';
import Icon from '../Icon';

(async () => {
  var controlElements = document.querySelectorAll('[aria-controls]');
  if (!controlElements || controlElements.length == 0) return;

  for (var initiator of controlElements) {
    const target = document.getElementById(
      initiator.getAttribute('aria-controls')
    );
    if (!target) continue;

    const iconElem = document.createElement('icon');
    if (iconElem) {
      ReactDOM.render(
        <Icon
          className="group-aria-expanded:rotate-180"
          name="caret-down"
          style={{ display: 'block', width: '1.5rem', height: '1.5rem' }}
        />,
        iconElem
      );
      initiator.appendChild(iconElem);
    }

    const collapsed = target.classList.contains('collapsed');

    initiator.setAttribute('aria-expanded', !collapsed);
    target.setAttribute('aria-hidden', collapsed);

    target.classList.add('collapsible__content');

    if (!collapsed) {
      target.style.height = target.offsetHeight + 'px';
    } else {
      target.style.height = 0;
      target.style.visibility = 'hidden';
    }

    initiator.addEventListener('click', (e) => {
      var initiator = e.target;
      var target = document.getElementById(
        initiator.getAttribute('aria-controls')
      );
      target.classList.toggle('collapsed');

      const isCollapsed = target.classList.contains('collapsed');
      target.setAttribute('aria-hidden', isCollapsed);
      initiator.setAttribute('aria-expanded', !isCollapsed);

      if (!isCollapsed) {
        target.style.visibility = 'hidden';
        target.style.padding = '0 0 1.6rem 0';
        target.style.height = 'auto';
        const height = target.offsetHeight;

        target.style.height = 0;
        target.style.padding = 0;
        target.style.visibility = 'visible';

        setTimeout(() => {
          target.style.height = height + 'px';
        }, 1);
      } else {
        target.style.height = 0;
        target.style.padding = 0;
        target.style.visibility = 'hidden';
      }
    });
  }
})();
